// ...existing code...
import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { ChartingCodeContext } from './lib/chartingCodeContext';



const ChartingCodeDebug = ({ template }) => {
	const context = useContext(ChartingCodeContext);
	return (
		<Box>
			<Box>
				Charting Code Template:<br />
				<textarea rows="20" cols="120" disabled value={JSON.stringify(template, null, 2)} />
			</Box>

			<Box>
				Context value:<br />
				<textarea rows="20" cols="120" disabled value={JSON.stringify(context, null, 2)} />
			</Box>
		</Box>
	);
};

export default ChartingCodeDebug;

